"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _attributeIds = _interopRequireDefault(require("@devsontap/nica-api/core/utils/attributeIds"));

var _selectors = require("../../../../redux/attributes/selectors");

var _icInfusionChairs = _interopRequireDefault(require("../../../../img/ic-infusion-chairs.svg"));

var _icLanguagesSpoken = _interopRequireDefault(require("../../../../img/ic-languages-spoken.svg"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuickFacts = function QuickFacts(_ref) {
  var location = _ref.location;
  var typeIcon = (0, _selectors.useAttributeIconSelector)(_attributeIds.default.practiceType);
  var outsidePatientsIcon = (0, _selectors.useAttributeIconSelector)(_attributeIds.default.acceptsOutsidePatients);
  var plansIcon = (0, _selectors.useAttributeIconSelector)(_attributeIds.default.acceptedHealthCarePlans);
  var attributeMap = (0, _selectors.useAttributeMapSelector)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-container flex"
  }, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "details-section-icon-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "details-section-icon"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "details-section-header headlineFont quick-facts-header"
  }, "Quick Facts"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex marginBottom25"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginRight15 flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: typeIcon,
    className: "quick-facts-icon",
    alt: "practice type"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-item-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-label headlineFont"
  }, "Practice Type"), /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-value"
  }, _buildValues(location.attributes, attributeMap, _attributeIds.default.practiceType)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex marginBottom25"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginRight15 flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _icInfusionChairs.default,
    className: "quick-facts-icon",
    alt: "infusion chairs"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-item-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-label headlineFont"
  }, "Infusion Chairs"), /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-value"
  }, location.numberOfChairs))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex marginBottom25"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginRight15 flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: outsidePatientsIcon,
    className: "quick-facts-icon",
    alt: "accepts outside patients"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-item-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-label headlineFont"
  }, "Accepts Outside Patients"), /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-value"
  }, _buildValues(location.attributes, attributeMap, _attributeIds.default.acceptsOutsidePatients)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex marginBottom25"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginRight15 flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: plansIcon,
    className: "quick-facts-icon",
    alt: "accepted health plans"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-item-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-label headlineFont"
  }, "Accepted Health Plans"), /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-value"
  }, _buildValues(location.attributes, attributeMap, _attributeIds.default.acceptedHealthCarePlans)))), location && location.languagesSpoken && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex marginBottom25"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginRight15 flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _icLanguagesSpoken.default,
    className: "quick-facts-icon",
    alt: "languages spoken"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-item-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-label headlineFont"
  }, "Languages Spoken"), /*#__PURE__*/_react.default.createElement("div", {
    className: "quick-facts-value"
  }, location.languagesSpoken))))));
};

function _getValuesForAttributeId(locationAttributes, attributeMap, attributeId) {
  var ret = [];

  if (locationAttributes && locationAttributes[attributeId]) {
    var choiceIds = locationAttributes[attributeId].choice;
    choiceIds.forEach(function (id) {
      ret.push(attributeMap[attributeId].options[id].name);
    });
  }

  return ret;
}

function _buildValues(locationAttributes, attributeMap, attributeId) {
  var values = _getValuesForAttributeId(locationAttributes, attributeMap, attributeId);

  if (values.length) {
    return values.map(function (value, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "fact-".concat(attributeId, "-").concat(index)
      }, value);
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", null, "This information is not available yet");
}

var _default = QuickFacts;
exports.default = _default;